import { Injectable } from '@angular/core';

@Injectable()
export class BuildNumberService {

  displayValue: string;

  constructor() { 

    let tags = document.getElementsByTagName("build-id");

    if(tags && tags.length > 0) {

      let displayElement = tags[0];
      
      if(displayElement && displayElement.hasAttribute("value")){
        this.displayValue = displayElement.getAttribute("value");
      }
    }
    else{
      this.displayValue = "LOCAL DEVELOPMENT";
    }
  }

}
